export interface Alert {
  id: string;
  /** String name or numeric enum from API/Elastic */
  eventType?: string | number;
  category?: string;
  subject: string;
  message: string;
  /** API/Elastic camelCase for MCode */
  mCode?: string | null;
  mcode?: string | null;
  clientName?: string | null;
  cCode?: string | null;
  ccode?: string | null;
  clientProductName?: string | null;
  relatedEntityType?: string | null;
  relatedEntityId?: string | null;
  whatChanged?: string | null;
  triggeredByUserId?: string | null;
  /** Same as audit logs */
  userName?: string | null;
  /** Same as audit logs */
  email?: string | null;
  /** Same as audit logs (e.g. LrNext, ClientPortal) */
  source?: string | null;
  createdAt: string;
  priority?: string;
  deepLink?: string | null;
  /** String name or numeric enum from API/Elastic */
  audience?: string | number | null;
  /** Which LRNext roles may see this alert (e.g. BillingAndClientServices) */
  visibleToRoles?: string | number | null;
  /** Assignee-only targeting (CaseExternalMessage) */
  targetEntraObjectId?: string | null;
  targetEmail?: string | null;
}

export function alertMCode(alert: Alert): string | null | undefined {
  return alert.mCode ?? alert.mcode;
}
